import { createSignal, createEffect, onCleanup, For } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Styles from "bundle-text:../styles/_verificationModal.scss";

interface VerificationModalProps {
  show: boolean;
  onClose: () => void;
  onNext: () => void;
}

const VerificationModal: Component<VerificationModalProps> = (props) => {
  const [code, setCode] = createSignal(Array(8).fill(""));
  const [inputs, setInputs] = createSignal([]);
  let inputRefs = [];

  // Focus next input on input
  const handleInput = (e, idx) => {
    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 1);
    const newCode = [...code()];
    newCode[idx] = val;
    setCode(newCode);

    if (val && idx < 8 - 1) {
      inputRefs[idx + 1].focus();
    }
  };

  // Handle backspace
  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !code()[idx] && idx > 0) {
      inputRefs[idx - 1].focus();
    }
  };

  // Handle paste
  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").replace(/[^a-zA-Z0-9]/g, "");
    if (paste.length) {
      const newCode = paste.slice(0, 8).split("");
      setCode((prev) => {
        const arr = [...prev];
        for (let i = 0; i < 8; i++) {
          arr[i] = newCode[i] || "";
        }
        return arr;
      });
      setTimeout(() => {
        const nextIdx = Math.min(paste.length, 8 - 1);
        inputRefs[nextIdx].focus();
      });
      e.preventDefault();
    }
  };

  // Set refs array
  createEffect(() => {
    setInputs(Array(8).fill(0));
  });

  // Clean up refs
  onCleanup(() => {
    inputRefs = [];
  });

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={40}>
        <HeaderModal title="Verification" onClose={props.onClose} />
        <div class="verification-modal-content">
          <p class="text">
            We've forwarded an email with a verification code, so you can go
            ahead, verify the code and enter it in the box below
          </p>
          <div class="inputs">
            <For each={inputs().slice(0, 4)}>
              {(_, idx) => (
                <input
                  ref={(el) => (inputRefs[idx()] = el)}
                  type="text"
                  maxlength="1"
                  value={code()[idx()]}
                  onInput={(e) => handleInput(e, idx())}
                  onKeyDown={(e) => handleKeyDown(e, idx())}
                  onPaste={handlePaste}
                  class="code-input"
                  autocomplete="one-time-code"
                />
              )}
            </For>
            <hr />
            <For each={inputs().slice(4, 8)}>
              {(_, idx) => (
                <input
                  ref={(el) => (inputRefs[idx() + 4] = el)}
                  type="text"
                  maxlength="1"
                  value={code()[idx() + 4]}
                  onInput={(e) => handleInput(e, idx() + 4)}
                  onKeyDown={(e) => handleKeyDown(e, idx() + 4)}
                  onPaste={handlePaste}
                  class="code-input"
                  autocomplete="one-time-code"
                />
              )}
            </For>
          </div>
          <button class="send" onClick={props.onSendAgain}>
            <builderall-icon code="594b"></builderall-icon>
            Send code again
          </button>
          <div class="alert">
            <builderall-icon code="5f09"></builderall-icon>
            <p>1 minute for the code to be present again...</p>
          </div>
          <footer>
            <button class="btn" onClick={() => props.onNext?.(code().join(""))}>
              Next
            </button>
          </footer>
        </div>
      </DefaultModal>
    </>
  );
};

export default VerificationModal;
